<template>
  <v-card class="text-center" flat>
    <v-card-title class="justify-center">
      <v-progress-circular
        v-if="loadingPaymentStatus"
        indeterminate
        color="blue"
        size="105"
        width="7"
      >
        <v-icon x-large color="blue">mdi-dots-horizontal</v-icon>
      </v-progress-circular>
      <v-icon v-else :color="color" size="128">{{ icon }} </v-icon>
    </v-card-title>

    <v-card-title class="headline justify-center">{{ title }}</v-card-title>

    <v-card-text class="mt-5">{{ message }}</v-card-text>

    <v-col v-if="!loadingPaymentStatus" cols="12" justify="center">
      <v-btn
        :class="showPositiveBtn ? 'primary-font-color' : 'd-none'"
        class="mb-3"
        color="primary"
        block
        large
        @click="onPositiveBtnClick"
      >
        {{ positiveBtnText }}
      </v-btn>
      <v-btn
        :class="showNegativeBtn ? '' : 'd-none'"
        class="mb-3"
        color="secondary"
        block
        large
        @click="onNegativeBtnClick"
      >
        {{ negativeBtnText }}
      </v-btn>
    </v-col>
  </v-card>
</template>

<script>
import doRequest from '@/api/dssRequest';

export default {
  name: 'PaymentStatus',
  props: {
    userId: String,
    /**
     * Either `orderId` or `paymentId` should be provided\
     * Invalid if both of them are null
     */
    orderId: String,
    paymentId: String,
    title: String,
    message: String,
    positiveBtnText: String,
    negativeBtnText: String,
  },
  data() {
    return {
      paymentStatus: '',
      loadingPaymentStatus: true,
      paymentSuccess: false,
      loadCounter: 0,
      loadCounterMax: 200,
      loadDelay: 5000, // Every 5 seconds
      icon: 'pending', // check_circle, error
      color: 'blue',
    };
  },
  computed: {
    partnerGroupId() {
      const pgDetails = this.$store.getters['Account/partnerGroupDetails'];
      return pgDetails.PartnerGroupId;
    },
    objectId() {
      let objId = this.partnerGroupId;
      if (this.userId) {
        objId = this.userId;
      }
      return objId;
    },
    showNegativeBtn() {
      if (this.negativeBtnText != null && this.negativeBtnText !== '') {
        return true;
      }
      return false;
    },
    showPositiveBtn() {
      if (this.positiveBtnText != null && this.positiveBtnText !== '') {
        return true;
      }
      return false;
    },
  },
  watch: {
    objectId() {
      this.getPaymentStatus();
    },
  },
  mounted() {
    this.getPaymentStatus();
  },
  methods: {
    getPaymentStatus() {
      if (!this.objectId) {
        return;
      }

      this.loadingPaymentStatus = true;

      if (this.loadCounter >= this.loadCounterMax) {
        // Reached the maximum trials, stop repeating the function
        this.paymentFailed();
        return;
      }

      const payload = {
        OrderId: this.orderId,
        PaymentId: this.paymentId,
      };

      doRequest(
        (response) => {
          if (response.data.OrderStatus != null) {
            this.paymentStatus = response.data.OrderStatus;

            if (this.paymentStatus === 'WaitingForPayment') {
              // Payment not done yet, check again
              setTimeout(this.getPaymentStatus, this.loadDelay);
            } else if (this.paymentStatus === 'Confirmed') {
              // Paid successfully
              this.paymentSucceeded();
            } else {
              this.paymentFailed();
            }
          } else {
            this.paymentFailed();
          }
        },
        () => {
          this.paymentFailed();
        },
        'getPaymentStatus',
        this.objectId,
        payload
      );

      this.loadCounter += 1;
    },
    paymentSucceeded() {
      this.loadingPaymentStatus = false;
      this.paymentSuccess = true;
      this.icon = 'check_circle';
      this.color = 'green';
      this.$emit('change', this.paymentStatus);
    },
    paymentFailed() {
      this.loadingPaymentStatus = false;
      this.paymentSuccess = false;
      this.icon = 'error';
      this.color = 'red';
      this.$emit('change', this.paymentStatus);
    },
    onPositiveBtnClick() {
      this.$emit('positive-btn-click');
    },
    onNegativeBtnClick() {
      this.$emit('negative-btn-click');
    },
  },
};
</script>
